import React, {useState, useEffect} from 'react';
import {PageHeader, Row, Col} from 'antd';
import MsgForm from '@/page/customer/MsgPage/Send/MsgForm';
import SendArea from '@/page/customer/MsgPage/Send/SendArea';
import MsgContext from '@/page/customer/MsgPage/msgContext';
import View from './View';
import styles from '../../index.module.less';
import {useEditAuthService} from '@/page/admin/adminService';

function MsgSend() {
    const editable = useEditAuthService(['global:customer_msg_send:w']);
    useEffect(() => {}, []);
    const [userIds, setUserIds] = useState([]);
    const [count, setCount] = useState(0);
    const [names, setNames] = useState('');
    const [sender, setSender] = useState({});
    const [sendType, setSendType] = useState(2);
    const [finalType, setFinalType] = useState('singleSender');
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [viewText, setViewText] = useState(null);
    const [viewLinks, setViewLinks] = useState([]);
    const [viewImages, setViewImages] = useState([]);
    const [viewVideos, setViewVideos] = useState([]);
    const [viewFiles, setViewFiles] = useState([]);

    function onSelect(subUserIds, id, sendType, users) {
        setSender(id);
        setUserIds(subUserIds);
        setSelectedUsers(users);
        setFinalType(sendType);
        // sendType === 'group' ? setSendType(2) : setSendType(1);
    }

    return (
        <MsgContext.Provider
            value={{
                count,
                setCount,
                userIds,
                setUserIds,
                sendType,
                setSendType,
                setSelectedUsers,
                selectedUsers,
                names,
                setNames,
                viewText,
                setViewText,
                viewImages,
                setViewImages,
                viewVideos,
                setViewVideos,
                viewFiles,
                setViewFiles,
                viewLinks,
                setViewLinks,
            }}
        >
            <div style={{overflowY: 'auto'}}>
                <PageHeader title="消息群发" />
                <Row className={styles.tableContainer}>
                    <Col span={12}>
                        <SendArea onSelect={onSelect} editable={editable}/>
                        <MsgForm
                            editable={editable}
                            userIds={userIds}
                            sender={sender}
                            sendType={finalType}
                            selectedUsers={selectedUsers}
                        />
                    </Col>
                    <Col span={8} offset={2}>
                        <View />
                    </Col>
                </Row>
            </div>
        </MsgContext.Provider>
    );
}

export default MsgSend;
